// Shared helpers for platform account numbers.
//
// River Pay is a special platform: the user sees the number grouped in pairs
// separated by hyphens, but it is always stored and sent as clean digits.

export const RIVER_PAY_LENGTH = 12;

// Detect River Pay from a platform key OR display name (e.g. "river_pay",
// "River Pay", "river-pay").
export const isRiverPayPlatform = (s?: string | null): boolean =>
  !!s && /river[\s_-]*pay/i.test(s);

// Strip everything that is not a digit.
export const cleanAccountNumber = (v?: string | null): string =>
  (v || '').replace(/\D/g, '');

// "770761876042" -> "77-07-61-87-60-42"
export const formatRiverPayNumber = (v?: string | null): string =>
  cleanAccountNumber(v).replace(/(\d{2})(?=\d)/g, '$1-');

// Display helper: River Pay -> hyphenated, others -> plain digits.
export const formatAccountNumberForDisplay = (
  v?: string | null,
  keyOrName?: string | null
): string => {
  const clean = cleanAccountNumber(v);
  return isRiverPayPlatform(keyOrName) ? formatRiverPayNumber(clean) : clean;
};